import { IframeWidget } from '.';
import { Log } from '../../AuxillaryService/Log';
import { Permission } from '../../Platform';
import { Signage } from '../../Signage';
import { JsonValue } from '../../Utility/JsonValue';
import { BaseIframeWidget } from './types';

/**
 * Virtual Iframe
 * @class
 */
export class VirtualIframe implements BaseIframeWidget {
    /**
     * Iframe widget object
     */
    widget: IframeWidget;

    constructor(widget: IframeWidget) {
        this.widget = widget;
    }

    /**
     * Does nothing.
     */
    render(): void {
        return;
    }

    /**
     * Does nothing.
     */
    async destroy(): Promise<void> {
        return;
    }

    /**
     * executes the given JS on the windowed Iframe
     */
    executeJS(jsToExec: string, executeInline?: boolean): Promise<JsonValue> | JsonValue {
        const execJs = () => {
            // used to make sure that the js is scoped to only be applied to the
            // target iframe were possible
            const scopedJs = jsToExec.replace(
                'document.querySelector',
                `document.querySelector("#widget_iframe_${this.widget.id}").contentDocument.querySelector`
            );

            // Emulate behavior used by windowed iframe.
            let ret: JsonValue;
            try {
                ret = eval(scopedJs) as JsonValue;
            } catch (exc) {
                // return a string starting with '[ERROR]' if the js errors out
                Log.Warning(
                    `Failed to execute JavaScript on handle #widget_iframe_${
                        this.widget.id
                    }: ${String(exc)}`,
                    null,
                    __fileline,
                    exc
                );
                return `[ERROR] ${String(exc)}`;
            }

            return ret;
        };

        if (executeInline) {
            return execJs();
        } else {
            return Promise.resolve(execJs());
        }
    }

    /**
     * Attempt to load iframe. Set user warning if that is not possible.
     */
    async attemptIframeLoad(): Promise<void> {
        const securedUrlRegex = new RegExp('^(https)://', 'i');
        const isSecuredUrl = securedUrlRegex.exec(this.widget.config.url);
        const hasRelaxedNetSecurity = Signage.platform.hasPermission(
            Permission.RELAXED_NET_SECURITY
        );

        if (hasRelaxedNetSecurity || isSecuredUrl) {
            this.widget
                .isFramePermitted()
                .then(() => {
                    return this.widget.setIframe();
                })
                .catch((err) => {
                    this.widget.setWarningDiv(err.message);
                });
        } else {
            //we have a very strong suspicion that this URL will not work because we
            //are not running on a platform which has relaxed net security and the
            //URL is `http`

            let message;
            if (Signage.isPreview) {
                message =
                    `<p>WARNING: Widget \`${this.widget.name}` +
                    '` cannot be rendered. (net security violation)</p>' +
                    "<p><a href='https://en.wikipedia.org/wiki/HTTPS' " +
                    "target='_blank'>About secure URLs</a></p>";
            }
            this.widget.setWarningDiv('net security violation', message);
        }

        // ignored promise.
        this.widget.startLoginScript();
    }
}
